const translationsMap = {
  button_next_label: "button.next",
  button_next_label: "navigation.next",

  // component_label: "", // duplicate of page title
  component_type_page_title: "bauteil.title",
  component_type_exposition_section_info: "bauteil.expositionDescription",
  component_type_exposition_section_title: "bauteil.exposition",
  component_type_page_subtitle: "bauteil.subtitle",

  concrete_thickness_info: "thickness.info",
  concrete_thickness_page_info_section_info: "thickness.info",
  concrete_thickness_page_info_section_title: "thickness.infoTitle",
  concrete_thickness_page_subtitle: "", // no subtitle on page
  concrete_thickness_page_title: "thickness.title",

  concrete_type_page_title: "concreteType.title",
  concrete_type_page_subtitle: "concreteType.subtitle",
  concrete_type_page_other_section_title: "concreteType.otherCement",
  concrete_type_page_other_section_message_label: "concreteType.otherCementDescription",
  concrete_type_page_other_section_contact_label: "concreteType.contactUs",
  concrete_type_page_select_variant_label: "concreteType.selectVariant",
  concrete_type_page_select_wz_value_label: "concreteType.wzValue",
  
  construction_type_page_title: "bauwerk.title",
  construction_type_page_subtitle: "bauwerk.subtitle",

  contact_form_title: "contact.navigation",
  contact_form_company_label: "contact.company",
  contact_form_email_label: "contact.email",
  contact_form_first_name_label: "contact.firstname",
  contact_form_last_name_label: "contact.lastname",
  contact_form_message_label: "contact.message",
  contact_form_placeholder_label: "",
  contact_form_submit_buttonn_label: "contact.submit",
  
  inspectability_bad_info: "bauteil.badDescription",
  inspectability_bad_title: "bauteil.bad",
  inspectability_good_info: "bauteil.goodDescription",
  inspectability_good_title: "bauteil.good",
  inspectability_label: "bauteil.inspectability",
  inspectability_info: "bauteil.inspectabilityDescription",
  
  location_page_subtitle: "standort.subtitle",
  location_page_title: "standort.title",
  
  login_page_password_label: "navigation.password",
  login_page_submit_button_label: "navigation.login",
  login_page_title: "navigation.title",
  
  navigation_sidebar_title: "navigation.lebenszeitberechnung",
  navigation_sidebar_step_one_label: "navigation.projektstandort",
  navigation_sidebar_step_two_label: "navigation.bauwerk",
  navigation_sidebar_step_three_label: "navigation.materials",
  navigation_sidebar_manual_label: "navigation.manual",
  
  result_page_expert_mode_concrete_thickness_label: "navigation.concreteThicknessExpert",
  result_page_expert_mode_concrete_thickness_sigma_label: "navigation.concreteThicknessSigma",
  result_page_expert_mode_diffusion_coefficient_mean_label: "navigation.diffussionCoeff",
  result_page_expert_mode_diffusion_coefficient_std_label: "navigation.diffussionCoeffStdev",
  result_page_expert_mode_chloride_exposition_mean_label: "navigation.chlorideExpositionMean",
  result_page_expert_mode_chloride_exposition_std_label: "navigation.chlorideExpositionStdev",
  result_page_expert_mode_concrete_coverage: "navigation.concreteCoverage",
  result_page_expert_mode_exposition_label: "bauteil.expositionExpert",
  
  result_page_find_more_block_title: "knowMoreCard.title",
  result_page_find_more_block_info: "knowMoreCard.description",
  result_page_find_more_block_contact_button_label: "knowMoreCard.contactUs",

  result_page_left_column_concrete_thickness_label: "navigation.concreteThickness",
  result_page_left_column_concrete_type_label: "navigation.concreteType",
  result_page_left_column_exposition_label: "", // not used
  result_page_left_column_lifetime_title: "navigation.lebenszeitberechnung",
  result_page_left_column_new_button_label: "navigation.createNew",
  result_page_left_column_reset_button_label: "navigation.reset",
  result_page_left_column_title_setting_title: "navigation.settings",
  result_page_left_column_title_title: "visualisation.title",
  result_page_left_column_title_title: "navigation.resultsTitle",
  result_page_left_column_export_csv_file_label: "navigation.exportCSV",

  result_page_main_area_black_steel_label: "concreteType.blackSteel",
  result_page_main_area_chart_x_label: "visualisation.chartXLabel",
  result_page_main_area_chart_y_label: "visualisation.chartYLabel",
  result_page_main_area_pdf_download_button_label: "visualisation.downloadPdf",
  result_page_main_area_previous_calculations_label: "visualisation.previousCalculations",
  result_page_main_area_show_chart_label: "visualisation.showChart",
  result_page_main_area_top12_steel_label: "concreteType.top12Steel",
  result_page_main_area_x_years_label: "concreteType.years",       
  
  faq_page_title: "faq.title",
  faq_page_info: "faq.info",
  faq_page_button_label: "faq.button",

  disclaimer_title: "disclaimer.title",
  disclaimer_info: "disclaimer.info",
  disclaimer_button_label: "disclaimer.buttonLabel"
}

export default translationsMap